import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { LegalPageBody } from "../components/LegalPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: Immutable<templates.LegalPageTemplate>,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <LegalPageBody page={props.page} />
    </PageSkeleton>
);
